// extracted by mini-css-extract-plugin
export default {"page":"Navigation_page__GLx2k","tiles":"Navigation_tiles__tP85g"};